var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "border-t-6 opacity-100 rounded p-8",
      class: [_vm.containerAccentClasses],
    },
    [
      _vm.messageHasTitle
        ? [
            _vm.options.html
              ? _c("h2", {
                  staticClass: "dg-title",
                  domProps: { innerHTML: _vm._s(_vm.messageTitle) },
                })
              : _c("h2", { staticClass: "dg-title" }, [
                  _vm._v(_vm._s(_vm.messageTitle)),
                ]),
          ]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "mb-4 mt-4", class: { "mt-8": _vm.messageHasTitle } },
        [
          _vm.options.html
            ? _c("div", {
                staticClass: "dg-content",
                domProps: { innerHTML: _vm._s(_vm.messageBody) },
              })
            : _c("div", { staticClass: "dg-content" }, [
                _vm._v(_vm._s(_vm.messageBody)),
              ]),
        ]
      ),
      _c("br"),
      _c(
        "div",
        { staticClass: "flex flex-row justify-between" },
        [
          _vm.options.showCancelText
            ? _c(
                "base-button",
                {
                  staticClass: "btn-secondary min-w-42",
                  on: { click: _vm.handleDismiss },
                },
                [_vm._v(" " + _vm._s(_vm.cancelText) + " ")]
              )
            : _c("div"),
          _c(
            "base-button",
            {
              staticClass: "ms-4 px-8 min-w-42",
              class: [_vm.buttonAccentClasses],
              on: { click: _vm.handleProceed },
            },
            [_vm._v(" " + _vm._s(_vm.okText) + " ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }